import { ApiResponse } from '@/types/api'
import { TBannerSetting } from '@/types/home'
import { httpClient } from './http-client'

export class __cBannerService {
  static async getBannerSettings() {
    try {
      const { data } = await httpClient.V4_NEW.get<ApiResponse<TBannerSetting>>(
        `/settings/banner-menu-setting`
      )
      return data || []
    } catch (error) {
      console.error('Failed to fetch main homepage settings:', error)
      return null
    }
  }
}
